import React, { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';

import { Explicitness, messages as m, SearchConstants, SearchStatsActions } from '../../constants';
import * as D from '../../deps';

interface ISearchListItemProps {
  activeUrl?: string;
  albumId?: string;
  artistName?: string;
  artUrl?: string;
  backstageUrl?: string;
  duration: number;
  iconName?: string;
  id: string;
  index?: number;
  intl?: $TSFixMe;
  isActiveSource: boolean;
  isClean: boolean;
  isCollected: boolean;
  isExplicit: boolean;
  isFinished: boolean;
  isGenreStation?: boolean;
  isHosted?: boolean;
  isPaused: boolean;
  isPlaying: boolean;
  isRadioOnly?: boolean;
  isShuffleStation?: boolean;
  isStation?: boolean;
  isUnavailable?: boolean;
  name?: string;
  normalizedType: D.Utils.SourceType.PandoraTypeValue;
  onItemSelect: $TSFixMeFunction;
  pauseTrack: $TSFixMeFunction;
  playResumeSource: $TSFixMeFunction;
  router: $TSFixMe;
  routeToStationDetailsFromFactoryId: $TSFixMeFunction;
  searchTerm?: string;
  searchType?: string;
  secondTextUrl?: string;
  seedId: string;
  showCuratedModesBadge?: boolean;
  showTakeoverModesBadge?: boolean;
  sourceCardMenuItems?: [];
  startStation: $TSFixMeFunction;
  stationId?: string;
  style: string;
  trackCount?: number;

  // Podcasts
  elapsedTime?: number;
  episodeCount?: number;
  podcastId?: string;
  programName?: string;
  publisherId?: string;
  publisherName?: string;
  releaseDate?: string;
  showNewBadge?: boolean;
  summary?: string;
}

export class SearchListItem extends React.Component<ISearchListItemProps> {
  static defaultProps = {
    style: SearchConstants.STYLE_NAV,
  };

  textClickHandler: $TSFixMeFunction = textUrl => {
    if (!D.isFilteredSearch(textUrl)) {
      this.props.onItemSelect(
        this.props.id,
        this.props.index,
        SearchStatsActions.NAVIGATE_BACKSTAGE,
      );
    }

    if (
      D.isStationType(this.props.normalizedType) &&
      !this.props.isCollected &&
      !this.props.isGenreStation
    ) {
      this.props.routeToStationDetailsFromFactoryId({
        pandoraId: this.props.id,
      });
    } else {
      this.props.router.push(textUrl);
    }
  };

  mainTextOnclick: $TSFixMeFunction = () => {
    return this.textClickHandler(this.props.backstageUrl);
  };

  secondTextOnclick: $TSFixMeFunction = () => {
    return this.textClickHandler(this.props.secondTextUrl);
  };

  onPlayClick: $TSFixMeFunction = () => {
    const id = this.props.id;
    if (D.isStationType(this.props.normalizedType)) {
      // Fire off a startStation action. In the case of search results, we always want to route the
      // user the now playing view.
      const startStationParams = {
        forceReroute: false,
        musicId: this.props.seedId,
        pandoraId: id,
        searchQuery: this.props.searchTerm,
        stationId: this.props.stationId,
      };
      this.props.startStation(startStationParams);
    } else {
      let forceRestartSourceIfPlaying = false;
      // This so we start the song source if it is currently playing in a parent source
      if (this.props.normalizedType === D.PandoraTypes.SONG) {
        forceRestartSourceIfPlaying = this.props.activeUrl === 'all' && !this.props.isActiveSource;
      }
      this.props.playResumeSource({
        context: D.Constants.Ads.Rewards.ContextTypes.SEARCH_PLAY,
        forceRestartSourceIfPlaying,
        id,
        pandoraType: this.props.normalizedType,
      });
    }
    this.props.onItemSelect(id, this.props.index, SearchStatsActions.PLAY);
    return;
  };

  getPodcastProgramMetadata: $TSFixMeFunction = () => {
    const { episodeCount, showNewBadge } = this.props;

    return (
      <D.PodcastProgramMetadata
        episodeCount={episodeCount}
        showNewBadge={showNewBadge}
        showSourceName={true}
      />
    );
  };

  getPodcastEpisodeMetadata: $TSFixMeFunction = () => {
    const { duration, releaseDate, elapsedTime, isFinished } = this.props;

    return (
      <D.PodcastEpisodeMetadata
        episodeDuration={duration}
        elapsedTime={elapsedTime}
        isFinished={isFinished}
        releaseDate={releaseDate}
        showSourceName={true}
        showDurationOnlyAsBadge={true}
      />
    );
  };

  getIntegrationData: $TSFixMeFunction = () => {
    return {
      id: this.props.id,
    };
  };

  render(): $TSFixMe {
    let info: string | ReactNode = this.props.artistName;
    let name: string | ReactNode = this.props.name;
    let playButton = this.onPlayClick;
    const isPlaying = this.props.isPlaying;
    let rightColText;
    const { artUrl, normalizedType, trackCount, duration, seedId } = this.props;
    const isArtistType = normalizedType === D.PandoraTypes.ARTIST;

    switch (normalizedType) {
      case D.PandoraTypes.ARTIST:
        info = <FormattedMessage {...m.artist} />;
        // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type '$TSFixMeFun... Remove this comment to see the full error message
        playButton = null;
        break;
      case D.PandoraTypes.STATION:
        info = <FormattedMessage {...m.station} />;
        name = seedId.includes('TT') ? (
          name
        ) : (
          <FormattedMessage {...m.stationName} values={{ name }} />
        );
        break;
      case D.PandoraTypes.USER_STATION:
        info = <FormattedMessage {...m.station} />;
        break;
      case D.PandoraTypes.PLAYLIST:
        info = <FormattedMessage {...m.playlist} />;
        rightColText = <FormattedMessage {...m.numSongs} values={{ trackCount }} />;
        if (trackCount === 0) {
          // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type '$TSFixMeFun... Remove this comment to see the full error message
          playButton = null;
        }
        break;
      case D.PandoraTypes.SONG:
        rightColText = D.Utils.Time.formatTime(duration);
        break;
      case D.PandoraTypes.ALBUM:
        rightColText = <FormattedMessage {...m.numSongs} values={{ trackCount }} />;
        break;
      case D.PandoraTypes.PODCAST:
        info = this.props.publisherName;
        rightColText = this.getPodcastProgramMetadata();
        break;
      case D.PandoraTypes.EPISODE:
        info = this.props.programName;
        rightColText = this.getPodcastEpisodeMetadata();
        break;
      default:
        break;
    }

    return (
      <D.AppContextIntegrationData data={this.getIntegrationData}>
        <D.RowItem
          rowOnclick={this.props.backstageUrl && this.mainTextOnclick}
          isFullRowLink={this.props.backstageUrl && this.mainTextOnclick}
          playButtonOnclick={playButton}
          pauseButtonOnclick={this.props.pauseTrack}
          hasPlusIcon={this.props.iconName === SearchConstants.ADD}
          mainText={name}
          mainTextOnclick={this.props.backstageUrl && this.mainTextOnclick}
          mainTextModifier={this.props.isHosted ? <D.VoiceIcon /> : null}
          secondText={info}
          secondTextOnclick={this.props.secondTextUrl && this.secondTextOnclick}
          imgUrl={artUrl}
          isImgCircle={isArtistType}
          qaMainText={D.QA.SLITFL}
          sourceCardMenuItems={!this.props.isShuffleStation ? this.props.sourceCardMenuItems : null}
          rightColChild={rightColText}
          isCollected={this.props.isCollected}
          isExplicit={this.props.isExplicit}
          isClean={this.props.isClean}
          isPlaying={isPlaying}
          isPaused={this.props.isPaused}
          isStation={this.props.isStation}
          isUnavailable={this.props.isUnavailable}
          isRadioOnly={this.props.isRadioOnly}
          isDisabled={this.props.isUnavailable || this.props.isRadioOnly}
          shouldLinkImg={isArtistType}
          isHosted={this.props.isHosted}
          hasTakeoverModes={this.props.showTakeoverModesBadge}
          hasCuratedModes={this.props.showCuratedModesBadge}
        />
      </D.AppContextIntegrationData>
    );
  }
}

export function mapStateToProps(state: $TSFixMe, ownProps: $TSFixMe): $TSFixMe {
  const isPandoraIdInCollection = D.getInDomain('collection.utils.isPandoraIdInCollection', false);
  const isAdvertiserStation = ownProps.seedId
    ? ownProps.seedId.startsWith(D.HybridStationSeedId)
    : false;
  const isThumbprintSeedId = ownProps.seedId === D.ThumbprintSeedId;

  let isUnavailable;
  let isRadioOnly;
  let showTakeoverModesBadge;
  let showCuratedModesBadge;
  const isStation = D.isStationType(ownProps.normalizedType) && !isAdvertiserStation;
  const isShuffleStation =
    D.getInDomain('playback.utils.getShuffleStationId')(state) === ownProps.stationId;
  const isGenreStation = D.getInDomain('playback.utils.isGenrePandoraId')(ownProps.seedId);
  const thumbPrintStationId = D.getInDomain('playback.utils.getThumbprintStationId')(state);
  const getThumbPrintPath = thumbPrintStationId
    ? D.getStationDetailsPathForStationId(thumbPrintStationId)
    : null;
  const isHosted = D.getInDomain('catalog.utils.isHosted')(state, ownProps.id);

  if (ownProps.rightsInfo) {
    isUnavailable = !ownProps.rightsInfo.hasInteractive && !ownProps.rightsInfo.hasRadioRights;
    isRadioOnly = !ownProps.rightsInfo.hasInteractive && ownProps.rightsInfo.hasRadioRights;
  }

  let stationId = ownProps.stationId;
  let apsSourceId = '';
  if (isStation) {
    showTakeoverModesBadge = D.isMegastarModesEnabled(state) && ownProps.hasTakeoverModes;
    stationId =
      stationId ||
      D.getInDomain('playback.utils.getStationIdFromStationFactoryId', null)(state, ownProps.id) ||
      D.getInDomain('playback.utils.getStationIdFromSeedPandoraId', null)(state, ownProps.id);

    const isAPSEnabled = D.Utils.Listener.isAPSPandoraStationEnabled(state);
    apsSourceId =
      isAPSEnabled && stationId
        ? D.getInDomain('playback.utils.getStationPandoraId')(state, stationId)
        : apsSourceId;
  }
  if (isGenreStation) {
    showCuratedModesBadge = ownProps.hasCuratedModes;
  }
  const sourceId = apsSourceId ? apsSourceId : stationId || ownProps.id;
  const isSourcePlaying = D.getInDomain('playback.utils.isSourcePlayingCurrently')(state, sourceId);
  const isAudioPlaying = D.getInDomain('playback.utils.isAudioPlaying')(state);
  const isPlaying =
    isAudioPlaying &&
    (isSourcePlaying ||
      D.getInDomain('playback.utils.isTrackPlayingCurrently')(state, ownProps.id));
  const isPaused = !isAudioPlaying && isSourcePlaying;

  const progressDetails = D.getInDomain('playback.utils.getPodcastEpisodeProgressById', null)(
    state,
    ownProps.id,
  );
  let elapsedTime = progressDetails ? progressDetails.get('elapsedTime') : 0;
  elapsedTime = isPlaying && !isPaused ? 0 : elapsedTime;
  const isFinished = progressDetails && progressDetails.get('isFinished');
  const badgeDetails = D.getInDomain('playback.utils.getPodcastProgramBadgeStatusById', null)(
    state,
    ownProps.id,
  );
  const showNewBadge = badgeDetails && badgeDetails.get('showBadge');

  const artist = D.getAnnotationsById(state, ownProps.artistId);
  let secondTextUrl;
  if (artist) {
    secondTextUrl = artist.get('shareableUrlPath');
  }
  // If search result is a collected/eligible thumbprint radio, backstageUrl should point to station detail page
  let backstagePath =
    typeof ownProps.backstageUrl === 'undefined' && isThumbprintSeedId
      ? getThumbPrintPath
      : ownProps.backstageUrl;
  let isCollected = isPandoraIdInCollection(state, ownProps.id, ownProps.albumId);
  let shareParentSourceId = isThumbprintSeedId ? thumbPrintStationId : ownProps.id;
  if (stationId && !isGenreStation) {
    isCollected =
      isCollected ||
      D.getInDomain('playback.utils.isOwnStation')(state, stationId) ||
      isShuffleStation;
    backstagePath = !isShuffleStation ? D.getStationDetailsPathForStationId(stationId) : null;
    shareParentSourceId = stationId;
  }

  const onAddToMyMusicClick: $TSFixMeFunction = () =>
    ownProps.onItemSelect(ownProps.id, ownProps.index, SearchStatsActions.COLLECT);

  let sourceCardMenuItems = null;
  if (!isThumbprintSeedId || (isThumbprintSeedId && thumbPrintStationId)) {
    sourceCardMenuItems = D.getSourceCardMenuItems({
      albumId: ownProps.albumId,
      isSharePossible: !isAdvertiserStation,
      onAddToMyMusicClick,
      pandoraId: ownProps.id,
      pandoraType: ownProps.normalizedType,
      shareParentSource:
        ownProps.normalizedType !== D.PandoraTypes.SONG
          ? {
              shareParentSourceId,
              shareParentSourceType: D.isStationType(ownProps.normalizedType)
                ? D.PandoraTypes.STATION
                : ownProps.normalizedType,
            }
          : {},
      state,
      stationId: ownProps.stationId,
    });
  }

  return {
    artUrl: isThumbprintSeedId ? D.Utils.Art.getThumbprintArt() : ownProps.artUrl,
    backstageUrl: backstagePath,
    elapsedTime,
    isActiveSource: D.getInDomain('playback.utils.isSourcePlayingCurrently')(state, ownProps.id),
    isClean: ownProps.explicitness === Explicitness.CLEAN,
    isCollected,
    isExplicit: ownProps.explicitness === Explicitness.EXPLICIT,
    isFinished,
    isGenreStation,
    isHosted,
    isPaused,
    isPlaying,
    isRadioOnly,
    isShuffleStation,
    isStation,
    isUnavailable,
    secondTextUrl,
    showCuratedModesBadge,
    showNewBadge,
    showTakeoverModesBadge,
    sourceCardMenuItems,
  };
}

// eslint-disable-next-line react-redux/mapDispatchToProps-returns-object
const mapDispatchToProps: $TSFixMeFunction = (dispatch: $TSFixMe) => {
  return bindActionCreators(
    {
      pauseTrack: D.Actions.UseCases.pauseTrack,
      playResumeSource: D.Actions.UseCases.playResumeSource,
      routeToStationDetailsFromFactoryId: D.getInDomain(
        'playback.actions.routeToStationDetailsFromFactoryId',
      ),
      startStation: D.Actions.UseCases.startStation,
    },
    dispatch,
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchListItem));
